import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { ScrollTarget } from 'models';

import { classNames } from 'uitk-react-utils';
import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';

import { onClickScrollToTarget } from 'utils/smooth-scroll';

const TrackedButton = ClickTracker(UitkPrimaryButton);

export interface RenderTrackedButtonProps {
  buttonMessage?: string;
  isFullWidth?: boolean;
  onClick?: () => void;
  rffr?: string;
  size?: UitkButtonSize;
}

export interface QuickReserveButtonProps {
  buttonMessage: string;
  target: ScrollTarget;
  price?: string;
  qualifier?: string;
  subText?: string;
  isFullWidth?: boolean;
  onButtonClick?: () => void;
  rffr?: string;
  isPriceRightAligned?: boolean;
  withPrice?: boolean;
}

export const QuickReserveButton: React.FunctionComponent<QuickReserveButtonProps> = ({
  target,
  price,
  qualifier,
  subText,
  buttonMessage,
  isFullWidth,
  onButtonClick,
  rffr,
  isPriceRightAligned,
  withPrice = true
}) => {
  const onClick = onButtonClick ? onButtonClick : () => onClickScrollToTarget(target);
  const priceWrappingClassName = classNames('uitk-cell', {
    'all-cell-fill all-r-padding-two uitk-type-right': isPriceRightAligned,
    'all-cell-shrink all-x-padding-two': !isPriceRightAligned
  });
  const btnWrappingClassName = classNames('uitk-cell all-cell-1-2 uitk-type-right', {
    'all-cell-shrink': isPriceRightAligned,
    'all-cell-fill': !isPriceRightAligned
  });

  const rffrId = rffr || '.StickyBookButton';

  if (!buttonMessage) {
    return null;
  }

  return (
    <>
      <div className={priceWrappingClassName}>
        {price &&
          withPrice && (
            <>
              <b data-stid="quick-reserve-price" className="uitk-cell all-cell-shrink uitk-type-500 uitk-type-bold">
                {price}
              </b>
              {qualifier && (
                <span className="uitk-cell all-y-gutter-half all-x-gutter-half uitk-type-200 all-cell-shrink">{qualifier}</span>
              )}
              {subText && <div className="uitk-cell all-y-gutter-half uitk-type-100 uitk-type-medium">{subText}</div>}
            </>
          )}
      </div>
      <div className={btnWrappingClassName}>
        <RenderTrackedButton buttonMessage={buttonMessage} isFullWidth={isFullWidth || false} onClick={onClick} rffr={rffrId} />
      </div>
    </>
  );
};

QuickReserveButton.displayName = 'QuickReserveButton';

export const RenderTrackedButton: React.FunctionComponent<RenderTrackedButtonProps> = ({
  buttonMessage,
  isFullWidth,
  onClick,
  rffr,
  size = UitkButtonSize.SMALL
}) => (
  <TrackedButton
    onClick={onClick}
    aria-labelledby="sticky-button"
    data-stid="sticky-button"
    rfrr={rffr}
    linkName="Sticky Book Button"
    text={buttonMessage}
    isFullWidth={isFullWidth}
    size={size}
  />
);

RenderTrackedButton.displayName = 'RenderTrackedButton';
